import { render, staticRenderFns } from "./UDIrecord.vue?vue&type=template&id=bcb2da4e&scoped=true"
import script from "./UDIrecord.vue?vue&type=script&lang=js"
export * from "./UDIrecord.vue?vue&type=script&lang=js"
import style0 from "./UDIrecord.vue?vue&type=style&index=0&id=bcb2da4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcb2da4e",
  null
  
)

export default component.exports